module.exports = __webpack_public_path__ + "img/g.ba7232d9.png";